// extracted by mini-css-extract-plugin
export default {"noiseGraf":"NoizeGraf_noiseGraf__HgCFs","noiseCanvas":"NoizeGraf_noiseCanvas__JpUHy"};